import React, { useEffect } from "react";
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

import StudioImg from '../Images/Studio.jpg';
import About from "../Images/About.jpg";
import corporateSocialResponsibilty from "../Images/corporateSocialResponsibilty.jpg";
import London from "../Images/Dubai.jpg";

const items = [
    {
        title: "About",
        imgSrc: About,
        imgAlt: "Office with large windows overlooking water",
        linkSrc: "about"
    },
    {
        title: "Corporate Social Responsibility",
        imgSrc: corporateSocialResponsibilty,
        imgAlt: "People sitting in a garden area",
        linkSrc: "corporate-social-responsibility"
    },
    {
        title: "Dubai",
        imgSrc: London,
        imgAlt: "Large office space with many desks and computers",
        linkSrc: "dubai"
    },
    // {
    //     title: "Abu Dhabi",
    //     imgSrc: London,
    //     imgAlt: "People working at desks with architectural models",
    //     linkSrc: "abu-dhabi"
    // }
];

const Studio = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={StudioImg} alt="Studio" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-3xl sm:text-4xl font-bold">Studio</h1>
                </div>
            </div>
            <div className="p-4 sm:p-8 md:p-16 max-w-[620px] mx-auto">
                <p className="text-lg mb-8 tracking-wider text-gray-700 font-light">
                    Architetive Designs is a global studio for sustainable architecture, urbanism, engineering, and design, founded in 2010. With offices across the world, the practice works as a single entity that is both ethnically and culturally diverse, with people central to all our endeavours.
                </p>
            </div>
            <div className="max-w-[900px] mx-4 md:mx-auto mb-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {items.map((item, index) => (
                        <Link to={`/studio/${item.linkSrc}`} key={index}>
                            <div className="bg-[#f5f5f5] rounded-lg overflow-hidden hover:shadow-md hover:scale-[1.01] transition-transform duration-200">
                                <img src={item.imgSrc} alt={item.imgAlt} className="w-full h-56 object-cover" />
                                <div className="px-6 py-4 flex justify-between items-center">
                                    <h2 className="text-lg md:text-2xl text-gray-500 font-semibold">{item.title}</h2>
                                    <button className="text-gray-500 p-3 bg-white rounded-full">
                                        <FaArrowRight />
                                    </button>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Studio;